import { Card } from "react-bootstrap";

type MetricCardProps = {
    title: string | null;
    value: string | null;
    subtitle: string | null;
    icon: any;
};


const MetricCard = ({ title, value, subtitle, icon }: MetricCardProps) => (
    <Card className="metric-card h-100 shadow-sm border">
        <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Card.Title as="h6" className="mb-0 ">
                    {title}
                </Card.Title>
                <img src={icon} alt={title ? title : "image"} />
            </div>
            <h3 className="mb-1">{value}</h3>
            <small className="">{subtitle}</small>
        </Card.Body>
    </Card>
);

export default MetricCard